export var CategoryEnum;
(function (CategoryEnum) {
    CategoryEnum["HABILITACAO"] = "Habilita\u00E7\u00E3o";
    CategoryEnum["VEICULOS"] = "Ve\u00EDculos";
    CategoryEnum["INFRACOES"] = "Infra\u00E7\u00F5es";
})(CategoryEnum || (CategoryEnum = {}));
